// extracted by mini-css-extract-plugin
export default {"group":"mNxO6E3j","mobile":"mobile","content":"ToObfDXB"};